import { useQuery } from "@tanstack/react-query"
import { UtilsService } from "../../client"
import { Box, Popover, Portal, Separator, Stack, Text } from "@chakra-ui/react"
import { FiX } from "react-icons/fi"

const getModuleVersions = () => {
    return {
        queryFn: async () => {
        const data = await UtilsService.moduleVersions()
            return data ?? { data: null, count: 0 }
        },
        queryKey: ["module_versions"],
    }
}

interface ModuleVersionsProps {
    isOpen: boolean
    onClose: () => void
}


const ModuleVersions = ({isOpen, onClose}: ModuleVersionsProps) => {
    const { data: versions } = useQuery(getModuleVersions())

    return (
        <Popover.Root open={isOpen} >
            <Popover.Trigger position="absolute" />
            <Portal>
                <Popover.Positioner>
                    <Popover.Content color="black" >
                        <Popover.CloseTrigger 
                            onClick={onClose}
                            pos="absolute"
                            right={0}
                            margin={1}
                            padding={1}
                            backgroundColor="main"
                            borderRadius={5}
                            color="white"
                            border="2px solid"
                            borderColor="main"
                            _hover={{
                                backgroundColor: "transparent",
                                color: "main",
                            }}
                            cursor="pointer"
                        >
                            <FiX />
                        </Popover.CloseTrigger>

                        <Popover.Arrow />

                        <Popover.Body>
                            <Popover.Title textAlign="center">Modul Versionen</Popover.Title>
                            {versions &&
                                Object.keys(versions).map((key, i)  => (
                                    <Box key={i}>
                                        <Stack direction="row" justifyContent="space-between">
                                            <Text>{key}</Text>
                                            <Text>{versions[key]}</Text>
                                        </Stack>
                                        <Separator />
                                    </Box>
                                ))
                            }
                            <Text mt={4} textAlign="center">Made with love and coffee by Medienproduktion</Text>
                        </Popover.Body>
                    </Popover.Content>
                </Popover.Positioner>
            </Portal>
        </Popover.Root>
    )
}
  
export default ModuleVersions